import { APIRoute } from '@/modules/utils'
import { SendTokenStatus } from './base'

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/payment/checkout',
}

export type Body = {
  stripeToken: string
  planID: string
  coupon?: string
}

export type Response = {
  id: string
  status: SendTokenStatus
}
